import { render, staticRenderFns } from "./VaultDeleteFilesConfirm.vue?vue&type=template&id=7f841908&"
import script from "./VaultDeleteFilesConfirm.vue?vue&type=script&lang=ts&"
export * from "./VaultDeleteFilesConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports